<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">To Amina<br/>
For your love, for your laughter<br/>
and for standing firm when weaker hearts succumb<br/><br/></p>
<p class="ded">And to Darius, my eternal love<br/>
I hope to be as good of a parent to you as my parents were to me</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-dedication.vue?28838050